// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2795b98b","455":"287d44d8","977":"ba9afe7b"}[chunkId] + ".chunk.js";
};